import { cn } from "./cn";

/**
 * SectionRail — WO#5 Neon-Editorial v2.
 *
 * Left-edge vertical progress rail borrowed from Claudio's mock:
 * a small ruler-like column of ticks with the section number ("01",
 * "02", ...) and a coral diamond marker on the currently active
 * section. Purely presentational.
 *
 * The rail is hidden below `md` — the mobile hero cannot afford
 * the horizontal budget.
 */
export function SectionRail({
  number,
  activeMarker = false,
  side = "left",
  className,
}: {
  number: string;
  activeMarker?: boolean;
  side?: "left" | "right";
  className?: string;
}) {
  const align = side === "left" ? "items-start" : "items-end";
  return (
    <div
      aria-hidden
      data-testid={`section-rail-${side}-${number}`}
      className={cn(
        "hidden md:flex flex-col gap-2",
        align,
        "text-text-muted font-mono select-none",
        className,
      )}
    >
      <span className="text-[11px] tracking-[0.24em] text-text-secondary">
        {number}
      </span>
      <div className="relative">
        <div
          className={cn(
            "w-px bg-gradient-to-b from-transparent via-border-strong to-transparent",
          )}
          style={{ height: 260 }}
        />
        {/* Tick marks */}
        <div className="absolute inset-0 flex flex-col justify-between">
          {Array.from({ length: 22 }).map((_, i) => (
            <span
              key={i}
              className={cn(
                "block h-px",
                side === "left" ? "-ml-0.5" : "-mr-0.5",
                i % 5 === 0
                  ? "w-2.5 bg-border-strong"
                  : "w-1.5 bg-border-soft",
              )}
            />
          ))}
        </div>
        {activeMarker && (
          <span
            aria-hidden
            className={cn(
              "absolute",
              side === "left" ? "left-0" : "right-0",
              "top-[38%] -translate-x-1/2",
              "block h-2 w-2 rotate-45",
              "bg-neon-coral shadow-glow-coral-sm",
            )}
          />
        )}
      </div>
    </div>
  );
}
